import React from 'react'
import { createMarkup } from '~/utils'
import styled from '@emotion/styled'
import { device, space, color } from '@ticketswap/solar'
import PropTypes from 'prop-types'

const Output = styled.article`
  color: ${color.spaceMedium};

  * + * {
    margin-top: ${space[16]};
  }

  @media ${device.tablet} {
    * + * {
      margin-top: ${space[24]};
    }
  }

  ul,
  ol {
    list-style: initial;
    padding-left: ${space[16]};
  }

  ol {
    list-style: decimal;
  }

  li {
    margin: ${space[8]} 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${color.space};
  }
`

const RichTextOutput = ({ body }) => (
  <Output
    dangerouslySetInnerHTML={createMarkup(
      body
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&#8221;/g, '"')
        .replace(/&#8220;/g, '"')
        .replace(' </ iframe', '</iframe')
    )}
  />
)

RichTextOutput.propTypes = {
  body: PropTypes.string.isRequired,
}

export default RichTextOutput
